"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.projectVersions = exports.projectGroupStatuses = exports.projectPaymentModes = exports.projectStatuses = void 0;
exports.projectStatuses = ['ACTIVE', 'INACTIVE', 'COMPLETED', 'ARCHIVED'];
exports.projectPaymentModes = ['TASK', 'PROJECT'];
exports.projectGroupStatuses = ['ACTIVE', 'INACTIVE'];
exports.projectVersions = ['V1', 'V2'];
//# sourceMappingURL=Projects.js.map